module.exports = __webpack_public_path__ + "img/YV.0c56f197.png";